import api from '@pray/shared/utils/api';

import type { AddSeedsToGroupResponse } from './types';

const GROUPS_URL = '/web/studio/admin/seed-emails/groups';

/**
 * Adds seeds to a group. The call is a union: seeds already in the group stay there and come back
 * in `already_member_count`, so a selection that overlaps the group is never an error.
 *
 * `putGroup` is the other write and it replaces the whole membership. This one is the Seeds page's,
 * where the admin never sees who else is in the group.
 */
export async function postGroupSeeds(groupId: string, seedIds: string[]) {
  const res = await api.executePostRequest<{ data: AddSeedsToGroupResponse }>(`${GROUPS_URL}/${groupId}/seeds`, {
    seed_ids: seedIds,
  });
  return res.data.data;
}
